// ── 출퇴근 관리 두 탭이 같이 쓰는 윗부분 틀 (2026-09-29) ─────────────────────────────
//   사용자: "달력, 직원별 상세 누르면 폼이 달라서 왔다갔다 — 통일". 두 탭이 이 틀 하나로 그려서
//   탭을 바꿔도 제목·버튼·탭·검색·토글이 **같은 자리**에 있다.
//     1줄: 제목·설명(+ 제목 아래 칩) ................ [달력|직원별 상세] [☰ 메뉴]
//     2줄: [이름 검색] [필터 버튼]
//     3줄: 왼쪽(월별|주별 / 재직중|전체) ...... 가운데(달력=◀ 2026년 9월 ▶ 오늘) ...... 오른쪽(달력=범례 / 상세=상태 배지)
//   인쇄: 2줄(검색·필터)만 숨긴다. 버튼은 달력 인쇄 CSS 가 따로 숨긴다.
import React from 'react';
import { Search } from 'lucide-react';
import {
  stdHeaderRow, stdPageTitle, stdPageSubtitle,
  stdSearchWrap, stdSearchInput, stdSearchIcon, stdSearchPcBox,
} from '../adminlayout/designStandard';

export default function AttendancePageHeader({
  isMobile, title, subtitle, belowTitle = null,
  tabSlot = null, menu = null,
  searchValue, onSearchChange, filterButton = null,
  toolbarLeft = null, toolbarCenter = null, toolbarRight = null,
}) {
  // 한 덩어리로 묶는다 — 상세 탭 바깥 틀이 grid(gap 10)라, 묶지 않으면 줄 사이에 10px 씩 더 벌어져 달력 탭과 달라진다.
  return (
    <div>
      <div style={stdHeaderRow(isMobile)}>
        <div style={{ minWidth: 0 }}>
          <h2 style={stdPageTitle}>{title}</h2>
          <div style={stdPageSubtitle}>{subtitle}</div>
          {belowTitle && <div style={{ marginTop: 8 }}>{belowTitle}</div>}
        </div>
        {/* 1줄 오른쪽 = [달력|직원별 상세] 스위치 + ☰ 메뉴 (2026-09-29 사용자 그림). 두 탭이 같은 것만 두어 자리가 안 흔들린다.
            버튼(예외 스케줄 등록·시간 설정·엑셀)은 ☰ 메뉴 안으로 들어갔다. */}
        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          {tabSlot}
          {menu}
        </div>
      </div>

      {/* 검색 줄 아래 40px — 앱 표준 검색칸 아래 간격(stdSearchWrap)과 같게 (2026-09-30 사용자 "간격 좀 넓혀줘", 24 → 40) */}
      <div className="no-print" style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 40 }}>
        <div style={isMobile ? { ...stdSearchWrap(isMobile), marginBottom: 0, flex: 1 } : stdSearchPcBox}>
          <Search size={15} style={stdSearchIcon} />
          <input
            style={stdSearchInput}
            placeholder="이름 검색"
            aria-label="이름 검색"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
        {filterButton}
      </div>

      {/* 3줄 = 왼쪽 · 가운데 · 오른쪽 (2026-09-29 사용자 그림 3차). 토글(월별|주별 / 재직중|전체)은 두 탭 모두 **왼쪽** —
          탭을 바꿔도 같은 자리. PC 는 가운데 칸이 화면 한가운데에 오게 좌우 칸을 같은 폭(1fr)으로 둔다.
          휴대폰은 한 줄에 다 안 들어가 왼쪽 → 가운데(가운데 정렬) → 오른쪽 순으로 쌓는다. */}
      {(toolbarLeft || toolbarCenter || toolbarRight) && (
        <div style={isMobile ? {
          display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: 10, marginBottom: 12,
        } : {
          display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) auto minmax(0, 1fr)', alignItems: 'center', gap: 12, marginBottom: 12,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', minWidth: 0 }}>{toolbarLeft}</div>
          {(!isMobile || toolbarCenter) && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, flexWrap: 'wrap' }}>{toolbarCenter}</div>
          )}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: isMobile ? 'flex-start' : 'flex-end', gap: 6, flexWrap: 'wrap', minWidth: 0 }}>
            {toolbarRight}
          </div>
        </div>
      )}
    </div>
  );
}
